<template>
  <Modal
    ref="modal"
    :title="content ? content.title.rendered : ''"
    class="modal-external-content"
  >
    <template v-slot:content>
      <slot v-if="isLoaded & !error">
        <article
          v-html="content.content.rendered"
          class="modal-external-content__embed"
        ></article>
      </slot>

      <slot v-else-if="error">
        <div class="modal-external-content__error">
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M3.75,10.747V17.5a3,3,0,0,0,3,3h10.5a3,3,0,0,0,3-3v-.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M20.25,13.747V7a3,3,0,0,0-3-3H6.75a3,3,0,0,0-3,3v.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M6.75 13.747L3.75 10.747 0.75 13.747" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.25 10.747L20.25 13.747 23.25 10.747" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12 7.021L12 13.021" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,16.4a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.4h0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>

          <h3>Content not found</h3>

          <p>We are sorry about this: something happened that we couldn't load the requested content. You could try again or visit our <a href="#" target="_blank">Frequently Asked Questions</a> to find the information you are looking for.</p>
        </div>
      </slot>

      <slot v-else>
        <p class="u-p-5 u-text-center">
          <LoadingSpinner />
        </p>
      </slot>
    </template>

    <template
      v-slot:footer
    >
      <Button
        @click="submit()"
        appearance="primary"
        :disabled="!isLoaded"
      >
        Fertig
      </Button>
    </template>
  </Modal>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';

import axios from 'axios';

import LoadingSpinner from '@/components/Common/LoadingSpinner';
import Modal from '@/components/Composer/Modal';
import Button from '@/components/Common/Button';

export default {
  name: 'ModalPostcardMotives',
  mixins: [UiMixin],
  components: {
    LoadingSpinner,
    Modal,
    Button
  },
  props: {
    params: {
      type: Object
    }
  },
  data () {
    return {
      error: false,
      isLoaded: false,
      content: null
    };
  },
  methods: {
    submit () {
      this.$refs.modal.close();
    }
  },
  created () {
    if (this.params.url) {
      let slug = new URL(this.params.url).pathname.match(/.*?\/composer-knowledgebase\/([^?]*)/);

      if (slug) {
        slug = slug[1].replace('/', '');
      } else {
        slug = null;
      }

      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/wp-json/wp/v2/pages?slug=${slug}`
        )
        .then((response) => {
          if (!response.data.length) {
            this.error = true;
          }

          if (response.data[0]) {
            this.content = response.data[0];

            // Ugly hack to remove any "elementor-col" classes because of Gridlex depency collision
            this.content.content.rendered = this.content.content.rendered.replace(/col-/g, '');

            this.isLoaded = true;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalExternalContent
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Modal component to load external content pages from WP.
 * @since 2022-08-11
**/

$component: 'modal-external-content';

.#{$component} {
  &__embed {
    ::v-deep {
      .wp-block-image {
        &.alignfull,
        &.size-large {
          width: 100%;
        }

        img {
          width: 100%;
          height: auto;
        }

        figcaption {
          display: block;
          @include padding(map-get($spacers, 2) 0);
          color: $ink-lighter;
          @include font-size($font-size-sm);
          text-align: center;
        }
      }
    }
  }

  &__error {
    color: $ink-lighter;
    text-align: center;

    svg {
      display: block;
      width: 128px;
      @include margin(0 auto map-get($spacers, 4));
      color: $ink-lightest;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
